import { mount } from "@vue/test-utils";
import TermsConditions from "@/components/core/modals/TermsConditions";

describe("TermsConditions component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(TermsConditions, {
      propsData: {
        show: true
      }
    });
  });

  it("Renders del component TermsConditions", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
